import {
	CREATE_CATEGORIES_START,
	CREATE_CATEGORIES_SUCCESS,
	CREATE_CATEGORIES_FAIL,
	GET_CATEGORIES_START,
	GET_CATEGORIES_SUCCESS,
	GET_CATEGORIES_FAIL,
	UPDATE_CATEGORY_START,
	UPDATE_CATEGORY_SUCCESS,
	UPDATE_CATEGORY_FAIL,
	DELETE_CATEGORY_START,
	DELETE_CATEGORY_SUCCESS,
	DELETE_CATEGORY_FAIL,
} from 'admin/constants';
import { notification } from 'antd';

import * as api from 'api';

export function getCategories() {
	return async dispatch => {
		try {
			dispatch({ type: GET_CATEGORIES_START });

			const result = await api.getCategories();

			if (result.success) {
				dispatch({ type: GET_CATEGORIES_SUCCESS, payload: { ...result.data } });
			} else {
				dispatch({ type: GET_CATEGORIES_FAIL });
			}
		} catch (e) {
			dispatch({ type: GET_CATEGORIES_FAIL });
		}
	};
}

export function updateCategory(data) {
	return async dispatch => {
		try {
			dispatch({ type: UPDATE_CATEGORY_START });

			const result = await api.updateCategory(data);

			if (result.success) {
				dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: { ...result.data } });
			} else {
				dispatch({ type: UPDATE_CATEGORY_FAIL });
			}

			return result;
		} catch (e) {
			dispatch({ type: UPDATE_CATEGORY_FAIL });
			return e;
		}
	};
}

export function createCategory(data) {
	return async dispatch => {
		try {
			dispatch({ type: CREATE_CATEGORIES_START });

			const result = await api.createCategory(data);

			if (result.success) {
				dispatch({ type: CREATE_CATEGORIES_SUCCESS, payload: { ...result.data } });
			} else {
				dispatch({ type: CREATE_CATEGORIES_FAIL });
			}

			return result;
		} catch (e) {
			dispatch({ type: CREATE_CATEGORIES_FAIL });
			return e;
		}
	};
}
export function deleteCategory(data) {
	return async dispatch => {
		try {
			dispatch({ type: DELETE_CATEGORY_START });

			const result = await api.deleteCategory({ ...data });

			if (result.success) {
				notification.success({
					message: 'Deleted',
					description: `${2} has been successfuly deleted`,
				});
				dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: { ...data } });
			} else {
				notification.error({ message: 'Error!', description: result.message });
				dispatch({ type: DELETE_CATEGORY_FAIL });
			}
		} catch (e) {
			dispatch({ type: DELETE_CATEGORY_FAIL });
		}
	};
}
